import * as DSAssetFamilies from 'customer-data-filters-ui/filterQueryFormat/DSAssetFamilies/DSAssetFamilies';
import * as ListSegConstants from 'customer-data-filters-ui/converters/listSegClassic/ListSegConstants';
import { CtaHasClicked, CtaHasNotClicked, CtaHasNotSeen, CtaHasSeen } from 'customer-data-filters-ui/filterQueryFormat/operator/Operators';
import { List, Map as ImmutableMap, Set as ImmutableSet } from 'immutable';
import { testDynamicFilterFamily } from 'customer-data-filters-ui/filterQueryFormat/DynamicFilterFamilies';
import FilterOperatorDescription from 'customer-data-filters-ui/filterQueryFormat/FilterOperatorDescription';
import FilterLogicGroup from './logic/FilterLogicGroup';
import { isLogicGroup } from 'customer-data-filters-ui/filterQueryFormat/logic/LogicGroup';
import { getLogicGroupConditionsSize } from './logic/LogicGroup';
import { isPropertyNameAndValueCondition } from '../strategy/propertyChangedFilterUtils';
export const getFilterDescription = (filterQuery, filterFamily) => {
  if (FilterLogicGroup.isFilterLogicGroup(filterQuery)) {
    return filterQuery.get('conditions').reduce((acc, query) => {
      const description = getFilterDescription(query, filterQuery.get('filterFamily'));
      if (List.isList(description)) {
        return acc.concat(description);
      }
      return acc.push(description);
    }, List());
  }
  return FilterOperatorDescription({
    filterFamily,
    operator: filterQuery
  });
};

// Gets all leaf node conditions and bundles them with the filter family of the
// containing logic group. Return Type: [{filterQuery, filterFamily}, ...]
const getLeafNodeConditionsWithFilterFamily = (filterQuery, filterFamily) => {
  if (!FilterLogicGroup.isFilterLogicGroup(filterQuery)) {
    return [{
      filterQuery,
      filterFamily
    }];
  }
  if (isLogicGroup(filterQuery) && getLogicGroupConditionsSize(filterQuery) === 0) {
    return [{
      filterQuery,
      filterFamily: filterQuery.filterFamily
    }];
  }
  return filterQuery.get('conditions').reduce((acc, query) => {
    const conditionsWithFilterFamilies = getLeafNodeConditionsWithFilterFamily(query, filterQuery.get('filterFamily'));
    acc.push(...conditionsWithFilterFamilies);
    return acc;
  }, []);
};
const noMappingHelper = () => [];
const ignoreValues = {
  [DSAssetFamilies.CONTACT_PROPERTY]: ListSegConstants.__PRIVACY_CONSENT,
  [DSAssetFamilies.FORM]: ListSegConstants.__ANY_FORM,
  [DSAssetFamilies.GOTO_WEBINAR_WEBINAR]: ListSegConstants.__ANY_WEBINAR
};
const defaultMappingHelper = (
// @ts-expect-error ts-migrate(7031) FIXME: Binding element 'value' implicitly has an 'any' ty... Remove this comment to see the full error message
{
  field: {
    name: value
  }
}, filterFamily) => {
  // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
  return ignoreValues[filterFamily] === value ? [] : [filterFamily, value];
};
const ctaMappingHelper = filterQuery => {
  const operatorUsesPlacementFamily = filterQuery instanceof CtaHasNotClicked || filterQuery instanceof CtaHasNotSeen || filterQuery instanceof CtaHasSeen || filterQuery instanceof CtaHasClicked;
  if (!operatorUsesPlacementFamily) {
    return [];
  }
  return filterQuery.value === ListSegConstants.__ANY_CTA ? [DSAssetFamilies.CTA, filterQuery.field.name] : [DSAssetFamilies.CTA_TO_PLACEMENT, filterQuery.value];
};

// Must return an empty array [] or a mapping in the form [key, value]
const filterFamilyMappingHelpers = {
  [DSAssetFamilies.CTA]: ctaMappingHelper,
  [DSAssetFamilies.PAGE_VIEW]: noMappingHelper,
  [DSAssetFamilies.EMAIL_SUBSCRIPTION]: noMappingHelper,
  [DSAssetFamilies.SMS_SUBSCRIPTION]: noMappingHelper,
  [DSAssetFamilies.WHATSAPP_SUBSCRIPTION]: noMappingHelper,
  [DSAssetFamilies.FORM]: defaultMappingHelper,
  [DSAssetFamilies.GOTO_WEBINAR_WEBINAR]: defaultMappingHelper,
  [DSAssetFamilies.EVENT]: defaultMappingHelper,
  DEFAULT: defaultMappingHelper
};
export const getMappingForCondition = ({
  filterQuery,
  filterFamily
}) => {
  if (testDynamicFilterFamily(DSAssetFamilies.INTEGRATION, filterFamily)) {
    return [DSAssetFamilies.INTEGRATION, filterFamily];
  }
  if (isLogicGroup(filterQuery)) {
    return [filterFamily, filterFamily];
  }
  if (isPropertyNameAndValueCondition(filterQuery)) {
    return [filterQuery.referencedObjectTypeId, filterQuery.propertyName];
  }
  return Object.prototype.hasOwnProperty.call(filterFamilyMappingHelpers, filterFamily) ?
  // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
  filterFamilyMappingHelpers[filterFamily](filterQuery, filterFamily) : filterFamilyMappingHelpers.DEFAULT(filterQuery, filterFamily);
};

// Returns a Map of Sets of field names keyed by filterFamilies
export const getUniqueFieldIdsByAssetFamily = filterQuery => {
  if (!filterQuery) {
    return ImmutableMap();
  }
  return getLeafNodeConditionsWithFilterFamily(filterQuery).reduce((acc, conditionWithFamily) => {
    const [key, value] = getMappingForCondition(conditionWithFamily);
    if (key) {
      const set = acc.has(key) ? acc.get(key).add(`${value}`) : ImmutableSet.of(`${value}`);
      return acc.set(key, set);
    }
    return acc;
  }, ImmutableMap());
};
export const getFilterFamilies = filterQuery => {
  return getLeafNodeConditionsWithFilterFamily(filterQuery).reduce((acc, {
    filterFamily
  }) => acc.add(filterFamily), ImmutableSet()).toList();
};